import React, {useState} from "react";
import "./filitered-map.styles.scss";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import {objData} from "./filitered-map.data";
import SelectList from "../../../commons/form-inputs/select-list/select-list.component";
import LocationsMap from "../google-map/google-map.component";
import SidebarLocations from "../sidebar-locations/sidebar.component";

function FilteredMap() {
  const [data, setData] = useState(objData);

  function filterContent(activeSection) {
    let newData = data.map((group) => {
        group.active = activeSection === group.section;
      return group;
    });

    setData(newData);
  }

  return (
    <div className="filtered-title-map">
      <SelectList
        className="d-md-none"
        onChange={(e) => filterContent(e.target.value)}
        defaultText="— Location Areas —"
        label="To view our locations, select an area."
      >
        <option value="" selected disabled hidden>
          — Location Areas —
        </option>
        {data.map(({ section, active }) => (
          <option
            className={`filter
                    ${active ? "active" : ""}
                `}
            value={section}
          >
            {section}
          </option>
        ))}
      </SelectList>

      <hr className="mobile-seperator d-md-none" />

      <div className="content">
        <div className="title-filters">
          {data.map(({ section, active }) => (
            <h3
              onClick={() => filterContent(section)}
              className={`filter
                    ${active ? "active" : ""}
                `}
            >
              {section}
            </h3>
          ))}
        </div>
        {data.map((group) => {
          if (group.active) {
            return (
              <Row>
                <Col md={7} lg={9} className="map">
                  <LocationsMap />
                </Col>
                <Col>
                  <SidebarLocations />
                </Col>
              </Row>
            );
          }
            return null;
        })}
      </div>
    </div>
  );
}

export default FilteredMap;
